import { isLoggedIn } from '~/lib/utils/common_utils';
import { detectAndConfirmSensitiveTokens } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/secret_detection.js?vue3';
import DiffDiscussions from '/builds/gitlab/gitlab-ee/app/assets/javascripts/rapid_diffs/app/discussions/diff_discussions.vue?vue3';
import NoteForm from '/builds/gitlab/gitlab-ee/app/assets/javascripts/rapid_diffs/app/discussions/note_form.vue?vue3';
import NoteSignedOutWidget from '/builds/gitlab/gitlab-ee/app/assets/javascripts/rapid_diffs/app/discussions/note_signed_out_widget.vue?vue3';
export default {
    name: 'CommitTimeline',
    components: {
        DiffDiscussions,
        NoteForm,
        NoteSignedOutWidget
    },
    inject: {
        store: {
            type: Object
        },
        userPermissions: {
            type: Object
        }
    },
    data () {
        return {
            isLoggedIn: isLoggedIn()
        };
    },
    methods: {
        async saveNote (noteText) {
            if (!noteText) return;
            const confirmSubmit = await detectAndConfirmSensitiveTokens({
                content: noteText
            });
            if (!confirmSubmit) return;
            await this.store.createNewDiscussion({
                note: noteText
            });
        }
    }
};
